import InnerComponent from '@Components/Sales/PackingSlip/PackingSlipForm';
import orgContainer from '@Components/AppContainer';

const CreatePackingSlip = () => ((orgContainer(InnerComponent)));
export default CreatePackingSlip;